import {useState}from "react";
import OrganisationBilling from "../OrganisationBilling";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/system";
import CustomerStat from "./CustomerStat";

export default function CustomerBillingDetail(props) {
    const [value,setvalue]=useState("1")
    const handleChange=(val)=>{
        setvalue(val)
    }
  return (
    <div>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList  aria-label="lab API tabs example">
            <Tab label="Reports" value="1" onClick={()=>{handleChange("1")}} />
            <Tab label = "Dashboard" value="2" onClick={()=>{handleChange("2")}}/>
            
          </TabList>
        </Box>
        <TabPanel value="1">
          <OrganisationBilling
            id={props.id}
            customerDetails={props.customerDetails}
          />
        </TabPanel>
        <TabPanel value="2"><CustomerStat id={props.id}/></TabPanel>
        
      </TabContext>
    </div>
  );
}
